import React, { Component } from "react";
import {
  Row,
  Col,
  Table,
  Drawer,
  Button,
  Popover,
  message,
  Tooltip,
  Input,
  InputNumber,
  Popconfirm
} from "antd";
import { CloseOutlined, FileDoneOutlined, RollbackOutlined, DeleteOutlined } from "@ant-design/icons";
import { withRouter, Link } from "react-router-dom";
import "./StakeHolder.css";
import PopConfirm from "../../../Components/MyComponent/PopConfirm";
import DelayConfirm from "../../../Components/MyComponent/DelayConfirm";
import RejectConfirm from "../../../Components/MyComponent/RejectConfirm";
import SelectStakeHolder from "./SelectStakeHolder";
import StakeHolderQuote from "./StakeHolderQuote";
import StakeHolderDoc from "./StakeHolderDoc";
import Number from "../../../Components/Number/Number";
import { API } from "../../../API/API";
import { baseConfig } from "../../../Config/Config";
import UserContext from "../../UserContext/UserContext";
const { TextArea } = Input;
const dateFormat = "YYYY.MM.DD HH:mm";
var moment = require("moment");
class StakeHolders extends Component {
  static contextType = UserContext;
  state = {
    data: [],
    status: this.props.status,
    invitationid: this.props.invitationid,
    tendername: this.props.tendername,
    showNewInputForm: false,
    showNewInputForm2: false,
    showNewInputForm3: false,
    selectedVendorId: 0,
    vendorname: "",
    isOpening: false,
    finishSelection: false,
    popConfirmVisible: false,
    popConfirmRejectVisible: false,
    popConfirmFinishVisible: false,
    popConfirmDelayVisible: false,
    opendate: this.props.opendate,
    delayDescription: "",
    delayAcceptDate: null,
    delayOpenDate: null,
    rejectDescription: "",
    note: null,
    tenderopenlog: "",
  };
  componentDidMount = () => {
    this.getData();
  };
  getData = () => {
    if (this.state.status !== 8) {
      API.get(
        "/getInvitationOfVendorList?invitationid=" + this.state.invitationid
      ).then((response) => {
        if (response.status === 200 && response.data.retType === 0) {
          this.setState({
            data: response.data.retData,
          });
        }
      });
      API.get(
        "/getTenderOpenLog?invitationid=" + this.state.invitationid
      ).then((response) => {
        if (response.status === 200 && response.data.retType === 0) {
          if (response.data.retData.length > 0) {
            this.setState({
              tenderopenlog: response.data.retData[0].membertypename,
            })
          }
        }
      });
    }
  };
  handleDelete = (id) => {
    API.get("deleteInvitationOfVendor?id=" + id).then((response) => {
      if (response.status === 200 && response.data.retType === 0) {
        const dataSource = [...this.state.data];
        this.setState({
          data: dataSource.filter((item) => item.id !== id),
        });
      }
    });
  };
  showNewInputFormHandler = (show, vendorid, vendorname) => {
    this.setState({
      showNewInputForm: show,
      selectedVendorId: vendorid,
      vendorname: vendorname,
    });
    if (!show) {
      this.getData();
    }
  };
  showNewInputFormHandler2 = (show, vendorid, vendorname) => {
    this.setState({
      showNewInputForm2: show,
      selectedVendorId: vendorid,
      vendorname: vendorname,
    });
  };
  showNewInputFormHandler3 = (show, vendorid, vendorname) => {
    this.setState({
      showNewInputForm3: show,
      selectedVendorId: vendorid,
      vendorname: vendorname,
    });
  };
  popConfirm = () => {
    return (
      <PopConfirm
        question={"Та тендерийг нээхдээ итгэлтэй байна уу?"}
        onClickYes={this.onOpenTender}
        onClickNo={() => this.onChangePopConfirmVisible(false)}
      />
    );
  };
  //#region delay Invitation
  popConfirmDelay = () => {
    return (
      <DelayConfirm
        onChangeDescription={(value) => { this.setState({ delayDescription: value.target.value }) }}
        onChangeAcceptDate={(value) => { this.setState({ delayAcceptDate: moment(value, dateFormat) }) }}
        onChangeOpenDate={(value) => { this.setState({ delayOpenDate: moment(value, dateFormat) }) }}
        onClickYes={this.onDelayTender}
        onClickNo={() => this.onChangeDelayVisible(false)}
      />
    );
  };
  onDelayTender = () => {
    this.setState({ popConfirmDelayVisible: false });
    let body = {
      url: baseConfig.makurl,
      session_id: localStorage.getItem("access_token"),
      delayedby: localStorage.getItem("username"),
      invitationid: this.state.invitationid,
      tendername: this.state.tendername,
      acceptdate: this.state.delayAcceptDate,
      opendate: this.state.delayOpenDate,
      description: this.state.delayDescription,
      status: 1
    }
    API.post("/delayInvitation", body).then((response) => {
      if (response.status === 200 && response.data.retType === 0) {
        message.success("Тендер амжилттай хойшлогдлоо.");
        this.setState({ status: 1 });
        this.props.history.push("/tender/3");
      }
    });
  };
  onChangeDelayVisible = (visible) => {
    this.setState({ popConfirmDelayVisible: visible });
  };
  //#endregion
  //#region reject Invitation
  popConfirmReject = () => {
    return (
      <RejectConfirm
        onChangeDescription={(value) => { this.setState({ rejectDescription: value.target.value }) }}
        onClickYes={this.onRejectTender}
        onClickNo={() => this.onChangePopConfirmRejectVisible(false)}
      />
    );
  };
  onRejectTender = () => {
    if (this.state.rejectDescription) {
      this.setState({ popConfirmRejectVisible: false });
      let body = {
        invitationid: this.state.invitationid,
        rejectby: localStorage.getItem("username"),
        rejectnote: this.state.rejectDescription,
      }
      API.post("/rejectInvitation", body).then((response) => {
        if (response.status === 200 && response.data.retType === 0) {
          message.success("Тендер амжилттай цуцлагдлаа.");
          this.setState({ status: 8 });
          this.props.history.push("/tender/4");
        }
      });
    }
    else {
      message.warning("Тайлбар талбарт утга оруулна уу.")
    }
  };
  onChangePopConfirmRejectVisible = (visible) => {
    this.setState({ popConfirmRejectVisible: visible });
  };
  //#endregion
  //#region finish Invitation
  popConfirmFinish = () => {
    return (
      <PopConfirm
        question={"Та шалгаруулалтыг дуусгахдаа байна уу?"}
        onClickYes={this.onFinishTender}
        onClickNo={() => this.onChangePopConfirmFinishVisible(false)}
      />
    );
  };
  onChangePopConfirmFinishVisible = (visible) => {
    this.setState({ popConfirmFinishVisible: visible });
  };
  onFinishTender = () => {
    this.setState({ popConfirmRejectVisible: false });
    API.get("/finishInvitation?invitationid=" + this.state.invitationid).then((response) => {
      if (response.status === 200 && response.data.retType === 0) {
        message.success("Шалгаруулалт амжилттай дууслаа.");
        this.setState({ status: 7 });
        this.props.history.push("/tender/4");
      }
    });
  };
  //#endregion
  onChangePopConfirmVisible = (visible) => {
    if (
      visible === true
    ) {
      if (moment(this.state.opendate, dateFormat) < moment(new Date(), dateFormat)) {
        this.setState({ popConfirmVisible: visible });
      }
      else {
        message.warning("Тендер нээх хугацаа болоогүй байна.")
      }
    }
    else {
      this.setState({ popConfirmVisible: false });
    }
  };
  onOpenTender = () => {
    if (this.state.note) {
      this.setState({ popConfirmVisible: false });
      API.get("/tenderOpenLog?empid=" + this.context.userid + "&invitationid=" + this.state.invitationid).then((response) => {
        if (response.status === 200 && response.data.retType === 0) {
          if (response.data.retData === 1) {//tender neeh tohirgoon deerhi buh gishuud neeh towch darsan ued tender neegdene
            this.setState({ isOpening: true, status: 3 });
            let body = {
              invitationid: this.state.invitationid,
              note: this.state.note,
              openby: localStorage.getItem("username")
            }
            API.post("/openInvitationOfVendor", body);
          }
          else {
            message.success("Нээх зөвшөөрөл амжилттай хийгдлээ.");
          }
        }
      });
    }
    else {
      message.warning("Тайлбар талбарт утга оруулна уу.")
    }
  };
  onChangeNote = (e) => {
    this.setState({ note: e.target.value });
  };
  render() {
    const columns = [
      {
        title: "Оролцогчийн нэр",
        dataIndex: "vendorname",
        key: "vendorname",
        width: "20%",
        align: "left",
        render: (text, record) => {
          return (
            <Tooltip title="Үнэлгээ өгөх">
              <Button
                disabled={this.state.status === 7 ? true : false}
                onClick={() => {
                  this.showNewInputFormHandler(
                    true,
                    record.vendorid,
                    record.vendorname
                  );
                }}
                type="link"
                style={{ fontWeight: "500", color: "#0358A7" }}
              >
                {record.vendorname}
              </Button>
            </Tooltip>
          );
        },
      },
      {
        title: "Үнийн санал",
        dataIndex: "totalamount",
        key: "totalamount",
        width: "15%",
        align: "left",
        render: (text, record) => {
          return <Button
            onClick={() => {
              this.showNewInputFormHandler3(
                true,
                record.vendorid,
                record.vendorname
              );
            }}
            type="link"
            style={{ fontWeight: "500", color: "#0358A7" }}
          >
            <Number symbol value={record.totalamount} />
          </Button>;
        },
      },
      {
        title: "Баримт",
        dataIndex: "countdoc",
        key: "countdoc",
        width: "20%",
        align: "left",
        render: (text, record) => {
          return (
            <Button
              onClick={() => {
                this.showNewInputFormHandler2(
                  true,
                  record.vendorid,
                  record.vendorname
                );
              }}
              type="link"
              style={{ fontWeight: "500", color: "#0358A7" }}
            >
              Хавсаргасан файл ({record.countdoc})
            </Button>
          );
        },
      },
      {
        title: "Нийт оноо",
        dataIndex: "totalpoint",
        key: "totalpoint",
        width: "10%",
        align: "left",
      },
      {
        title: "Батлагдсан үнэ",
        dataIndex: "approvedamount",
        key: "approvedamount",
        width: "10%",
        align: "left",
        render: (text, record) => {
          return (
            <div>
              <InputNumber
                placeholder="___._"
                style={{ width: "100%" }}
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                disabled
                size="middle"
                defaultValue={record.approvedamount}
              />
            </div>
          )
        }
      },
      {
        title: "Үр дүн",
        dataIndex: "status",
        key: "status",
        width: "10%",
        align: "left",
        render: (text, record) => {
          return (
            <div>
              {record.status === 5
                ? "Шалгарсан"
                : record.status === 4
                  ? "Шалгараагүй"
                  : "Үр дүн гараагүй"}
            </div>
          );
        },
      },
      {
        title: "Тайлбар",
        dataIndex: "note",
        key: "note",
        width: "20%",
        align: "left",
      },
      {
        title: " ",
        dataIndex: "operation",
        width: "3%",
        render: (_, record) =>
          this.state.status === 8 ? ( //Цуцалсан төлөвтэй үед устгаж болно.
            <Popconfirm
              title="Уcтгахдаа итгэлтэй байна уу?"
              onConfirm={() => this.handleDelete(record.id)}
            >
              <Button
                type="link"
                icon={<DeleteOutlined style={{ color: "red" }} />}
              />
            </Popconfirm>
          ) : null,
      },
    ];
    return (
      <div className="Container">
        {this.state.isOpening || this.state.status > 1 ? (
          <div id="stakeholder" style={{ marginTop: 20 }}>
            <Table
              dataSource={this.state.data}
              columns={[
                {
                  title: "№",
                  dataIndex: "key",
                  key: "key",
                  width: "3%",
                  render: (text, row, index) => (
                    <>{this.state.data.indexOf(row) + 1}</>
                  ),
                },
                ...columns,
              ]}
              pagination={false}
              rowKey="companyid"
              scroll={{ y: 340 }}
            />
            <Row justify="start" style={{ marginTop: 10 }}>
              <Col>
                {this.context.permission.isHold === "1" ?
                  <Popover
                    placement="bottomRight"
                    title="Хойшлуулах"
                    content={this.popConfirmDelay}
                    trigger="click"
                    visible={this.state.popConfirmDelayVisible}
                  >
                    <Button
                      type="primary"
                      style={{
                        backgroundColor: "#0358A7",
                        borderRadius: 4,
                        marginTop: 20,
                        marginLeft: 10
                      }}
                      htmlType="submit"
                      icon={<RollbackOutlined />}
                      onClick={() => this.onChangeDelayVisible(true)}
                    >
                      Хойшлуулах
                    </Button>
                  </Popover>
                  : null}
              </Col>
              <Col>
                {this.context.permission.isClose === "1" ?
                  <Popover
                    placement="bottomRight"
                    title="Санамж"
                    content={this.popConfirmFinish}
                    trigger="click"
                    visible={this.state.popConfirmFinishVisible}
                  >
                    <Button
                      type="primary"
                      style={{
                        backgroundColor: "#0358A7",
                        borderRadius: 4,
                        marginTop: 20,
                      }}
                      htmlType="submit"
                      icon={<FileDoneOutlined />}
                      onClick={() => this.onChangePopConfirmFinishVisible(true)}
                    >
                      Шалгаруулалт дуусгах
                    </Button>
                  </Popover>
                  : null}
              </Col>
              <Col>
                {this.context.permission.isCancel === "1" ?
                  <Popover
                    placement="bottomRight"
                    title="Цуцлах"
                    content={this.popConfirmReject}
                    trigger="click"
                    visible={this.state.popConfirmRejectVisible}
                  >
                    <Button
                      type="primary"
                      style={{
                        backgroundColor: "#0358A7",
                        borderRadius: 4,
                        marginTop: 20,
                        marginLeft: 10
                      }}
                      htmlType="submit"
                      icon={<CloseOutlined />}
                      onClick={() => this.onChangePopConfirmRejectVisible(true)}
                    >
                      Цуцлах
                    </Button>
                  </Popover>
                  : null}
              </Col>
            </Row>
          </div>
        ) : (//Tender neeh
          <div>
            <Row style={{ marginTop: 30 }} gutter={(16, 16)}>
              <Col span={24}>
                <div className="Label" style={{ marginBottom: 5 }}>
                  Тайлбар
                </div>
                <TextArea
                  rows={4}
                  defaultValue={this.state.note}
                  onChange={this.onChangeNote}
                />
              </Col>
            </Row>
            <Row justify="start" align="middle">
              <Col style={{ marginRight: 10 }}>
                {this.context.permission.isHold === "1" ?
                  <Popover
                    placement="bottomRight"
                    title="Хойшлуулах"
                    content={this.popConfirmDelay}
                    trigger="click"
                    visible={this.state.popConfirmDelayVisible}
                  >
                    <Button
                      type="primary"
                      style={{
                        backgroundColor: "#0358A7",
                        borderRadius: 4,
                        marginTop: 20,
                        marginLeft: 10
                      }}
                      htmlType="submit"
                      icon={<RollbackOutlined />}
                      onClick={() => this.onChangeDelayVisible(true)}
                    >
                      Хойшлуулах
                    </Button>
                  </Popover>
                  : null}
              </Col>
              <Col>
                <Popover
                  placement="bottomRight"
                  title="Санамж"
                  content={this.popConfirm}
                  trigger="click"
                  visible={this.state.popConfirmVisible}
                >
                  <Button
                    type="primary"
                    style={{
                      backgroundColor: "#0358A7",
                      borderRadius: 4,
                      marginTop: 20,
                    }}
                    htmlType="submit"
                    onClick={() => this.onChangePopConfirmVisible(true)}
                  >
                    Тендер нээх
                  </Button>
                </Popover>
              </Col>
              <Col>
                {/* {this.context.permission.isCancel === "1" ? */}
                  <Popover
                    placement="bottomRight"
                    title="Цуцлах"
                    content={this.popConfirmReject}
                    trigger="click"
                    visible={this.state.popConfirmRejectVisible}
                  >
                    <Button
                      type="primary"
                      style={{
                        backgroundColor: "#0358A7",
                        borderRadius: 4,
                        marginTop: 20,
                        marginLeft: 10
                      }}
                      htmlType="submit"
                      icon={<CloseOutlined />}
                      onClick={() => this.onChangePopConfirmRejectVisible(true)}
                    >
                      Цуцлах
                    </Button>
                  </Popover>
                  {/* : null} */}
              </Col>
              <Col>
                <div
                  style={{
                    fontSize: 14,
                    color: "#212121",
                    marginTop: 15,
                    marginLeft: 15,
                  }}
                >
                  Тендер нээх огноо: {this.state.opendate} {this.state.tenderopenlog !== "" ? ", Үнэлгээний хорооны " + this.state.tenderopenlog + " тендер нээх үйлдэл хийсэн байна." : null}
                </div>
              </Col>
            </Row>
          </div>
        )}
        <Drawer
          title={this.state.vendorname}
          width="500px"
          placement="right"
          visible={this.state.showNewInputForm}
          onClose={() => this.showNewInputFormHandler(false, 0, "")}
          destroyOnClose={true}
          style
        >
          <SelectStakeHolder
            showForm={this.showNewInputFormHandler}
            invitationid={this.state.invitationid}
            vendorid={this.state.selectedVendorId}
          ></SelectStakeHolder>
        </Drawer>
        <Drawer
          title={this.state.vendorname}
          width="500px"
          placement="right"
          visible={this.state.showNewInputForm2}
          onClose={() => this.showNewInputFormHandler2(false, 0, "")}
          destroyOnClose={true}
          style
        >
          <StakeHolderDoc
            invitationid={this.state.invitationid}
            vendorid={this.state.selectedVendorId}
          ></StakeHolderDoc>
        </Drawer>
        <Drawer
          title={this.state.vendorname}
          width="500px"
          placement="right"
          visible={this.state.showNewInputForm3}
          onClose={() => this.showNewInputFormHandler3(false, 0, "")}
          destroyOnClose={true}
          style
        >
          <StakeHolderQuote
            invitationid={this.state.invitationid}
            vendorid={this.state.selectedVendorId}
          ></StakeHolderQuote>
        </Drawer>
      </div>
    );
  }
}

export default withRouter(StakeHolders);
